import { RoleType } from "../user/types";
import { NodeEnvironment, getNodeEnvironment } from "./nodeEnvironment";
export const FRONTEND_SELECTORS = {
    APP: "#app",
    HEADER: "#h",
    FOOTER: ".footer-wrapper",
};
//delay in milleseconds for debouncing
export const DEBOUNCE_DELAY = 800;
export var APPLICATION_URL;
(function (APPLICATION_URL) {
    APPLICATION_URL["TEST"] = "http://localhost:3000";
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    APPLICATION_URL["DEVELOPMENT"] = "http://localhost:3000";
    APPLICATION_URL["BETA"] = "https://beta.checkout.aws.training";
    APPLICATION_URL["GAMMA"] = "https://gamma.checkout.aws.training";
    APPLICATION_URL["PROD"] = "https://checkout.aws.training";
})(APPLICATION_URL || (APPLICATION_URL = {}));
export const ALLOWED_ROLES = [
    RoleType.SUPER_USER,
    RoleType.INTERNAL_EMPLOYEE,
    RoleType.SERVICE,
    RoleType.POST_AUTH_PRE_VIAS,
];
export const ALLOWED_ROLES_BULK_OPERATION = [
    RoleType.SUPER_USER,
    RoleType.INTERNAL_EMPLOYEE,
    RoleType.LEARNING_ADMIN,
    RoleType.SERVICE,
    RoleType.POST_AUTH_PRE_VIAS,
    RoleType.LEARNING_ACCOUNT_IT_CONTACT,
];
export const EMAIL_VERIFICATION_ERROR = "EmailAddress is not verified, verification required.";
const endpoints = {
    [NodeEnvironment.TEST]: `${APPLICATION_URL.TEST}/graphql`,
    [NodeEnvironment.DEVELOPMENT]: `${APPLICATION_URL.DEVELOPMENT}/graphql`,
    [NodeEnvironment.BETA]: `${APPLICATION_URL.BETA}/graphql`,
    [NodeEnvironment.GAMMA]: `${APPLICATION_URL.GAMMA}/graphql`,
    [NodeEnvironment.PROD]: `${APPLICATION_URL.PROD}/graphql`,
};
export const getClientEndpoint = () => {
    if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
        return endpoints[NodeEnvironment.TEST];
    }
    return endpoints[getNodeEnvironment()] || endpoints[NodeEnvironment.TEST];
};
export var SignInMethod;
(function (SignInMethod) {
    SignInMethod["BUILDER_ID"] = "BUILDER_ID";
    SignInMethod["PARTNER_NETWORK"] = "PARTNER_NETWORK";
    SignInMethod["SSO"] = "SSO";
})(SignInMethod || (SignInMethod = {}));
export var OptOutReason;
(function (OptOutReason) {
    OptOutReason["BUDGET_CONSTRAINTS"] = "Budget Constraints";
    OptOutReason["NO_LONGER_NEEDED"] = "No Longer Needed";
})(OptOutReason || (OptOutReason = {}));
export const PARTNER_TYPE = {
    ATP: "ATP",
    DISTI: "DISTI"
};
export var AwsAccountType;
(function (AwsAccountType) {
    AwsAccountType["PARTNER"] = "partner";
    AwsAccountType["REGULAR"] = "regular";
})(AwsAccountType || (AwsAccountType = {}));
export const AUTO_RENEWAL_CONFIG = {
    [NodeEnvironment.BETA]: true,
    [NodeEnvironment.GAMMA]: true,
    [NodeEnvironment.PROD]: false,
    [NodeEnvironment.DEVELOPMENT]: true,
    [NodeEnvironment.TEST]: true
};
export const isAutoRenewalEnabled = () => {
    const currentEnv = getNodeEnvironment();
    return AUTO_RENEWAL_CONFIG[currentEnv] || false;
};
export var SessionKey;
(function (SessionKey) {
    SessionKey["AWS_ACCOUNT_ID"] = "AwsAccountId";
    SessionKey["AWS_ACCOUNT_JWT"] = "AwsAccountJwt";
    SessionKey["AWS_ACCOUNT_TYPE"] = "AwsAccountType";
    SessionKey["IS_AMAZON_TRAINING_PARTNER"] = "isAmazonTraininPartner";
    SessionKey["OTP_EMAIL"] = "otpEmail";
    SessionKey["LANGUAGE"] = "language";
    SessionKey["SUBSCRIPTION_REQUEST_ID"] = "subscriptionRequestId";
    SessionKey["PARENT_SUBSCRIPTION_REQUEST_ID"] = "parentSubscriptionRequestId";
    SessionKey["TOTAL_EXISTING_SEATS"] = "totalExistingSeats";
    SessionKey["REQUEST_TYPE"] = "requestType";
})(SessionKey || (SessionKey = {}));
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["REQUEST_SUBMITTED"] = "REQUEST_SUBMITTED";
    SubscriptionStatus["ONBOARDING_IN_PROCESS"] = "ONBOARDING_IN_PROCESS";
    SubscriptionStatus["ACTIVE"] = "ACTIVE";
    SubscriptionStatus["CANCELLATION_IN_PROGRESS"] = "CANCELLATION_IN_PROGRESS";
})(SubscriptionStatus || (SubscriptionStatus = {}));
export var SubscriptionRequestType;
(function (SubscriptionRequestType) {
    SubscriptionRequestType["NEW"] = "NEW";
    SubscriptionRequestType["MIDTERM"] = "MIDTERM";
    // Todo when renewal and cancellation are implemented
    //  RENEWAL = "Renewal"
    // CANCELLATION = "Cancellation"
})(SubscriptionRequestType || (SubscriptionRequestType = {}));
export const NAME_REGEX = /^[A-Za-z]+$/;
export const EMAIL_REGEX = /^[A-Za-z0-9._%+-]{1,60}@[A-Za-z0-9.-]{1,60}.[A-Za-z.]{2,}$/i;
export const COMPANY_NAME_REGEX = /^[a-zA-Z0-9]([a-zA-Z0-9]|[- ,()@.#&!]){1,59}$/;
export const OPPORTUNITY_REGEX = /^[a-zA-Z0-9]{1,18}$/;
export const MAX_ALLOWED_SPMS_ID_VALIDATION_ATTEMPTS = 5;
export const MAX_SUBSCRIPTION_TRAILING_12_MONTH_REGULAR_CUSTOMER = 5;
export const MAX_SUBSCRIPTION_TRAILING_12_MONTH_ATP_CUSTOMER = 500;
export const MAX_NUMBER_OF_MIDTERM_SEATS = 10000;
export const MIN_NUMBER_OF_MIDTERM_SEATS = 1;
export const MAX_MIDTERM_SUBSCRIPTIONS_ALLOWED = 3;
export const MINIMUM_SBTS_SEATS_PER_REQUEST_CUSTOMER = 5;
export const MINIMUM_SBTS_SEATS_PER_REQUEST_PARTNER = 2;
export const OPT_OUT_REASON_REGEX = /^[a-zA-Z0-9\s.,!?()-]{1,500}$/;
export const YES_VALUE = "yes";
export const NO_VALUE = "no";
export const GANDALF_LOGOUT_BETA_CLIENT_ID = "2vliolur9qc4rq501ieptp00m5";
export const GANDALF_LOGOUT_GAMMA_CLIENT_ID = "4p6f3kl3c0u3k2ra9h0plev14s";
export const GANDALF_LOGOUT_PROD_CLIENT_ID = "1c2h86t2drhtblt9im3m87r5hn";
export const COOKIE_EXPIRY_DATE = 'Thu, 01 Jan 1970 00:00:00 GMT';
export const COOKIE_PATH = '/';
export const COUNTRY_DETAILS = [
    // AMER
    { region: 'AMER', name: 'Argentina', code: 'ARG' },
    { region: 'AMER', name: 'Barbados', code: 'BRB' },
    { region: 'AMER', name: 'Belize', code: 'BLZ' },
    { region: 'AMER', name: 'Bolivia', code: 'BOL' },
    { region: 'AMER', name: 'Brazil', code: 'BRA' },
    { region: 'AMER', name: 'Canada', code: 'CAN' },
    { region: 'AMER', name: 'Chile', code: 'CHL' },
    { region: 'AMER', name: 'Colombia', code: 'COL' },
    { region: 'AMER', name: 'Costa Rica', code: 'CRI' },
    { region: 'AMER', name: 'Cuba', code: 'CUB' },
    { region: 'AMER', name: 'Dominica', code: 'DMA' },
    { region: 'AMER', name: 'Dominican Republic', code: 'DOM' },
    { region: 'AMER', name: 'Ecuador', code: 'ECU' },
    { region: 'AMER', name: 'El Salvador', code: 'SLV' },
    { region: 'AMER', name: 'Grenada', code: 'GRD' },
    { region: 'AMER', name: 'Guatemala', code: 'GTM' },
    { region: 'AMER', name: 'Guyana', code: 'GUY' },
    { region: 'AMER', name: 'Honduras', code: 'HND' },
    { region: 'AMER', name: 'Jamaica', code: 'JAM' },
    { region: 'AMER', name: 'Mexico', code: 'MEX' },
    { region: 'AMER', name: 'Nicaragua', code: 'NIC' },
    { region: 'AMER', name: 'Panama', code: 'PAN' },
    { region: 'AMER', name: 'Paraguay', code: 'PRY' },
    { region: 'AMER', name: 'Peru', code: 'PER' },
    { region: 'AMER', name: 'Saint Kitts and Nevis', code: 'KNA' },
    { region: 'AMER', name: 'Saint Lucia', code: 'LCA' },
    { region: 'AMER', name: 'Saint Vincent and the Grenadines', code: 'VCT' },
    { region: 'AMER', name: 'Suriname', code: 'SUR' },
    { region: 'AMER', name: 'Trinidad and Tobago', code: 'TTO' },
    { region: 'AMER', name: 'United States', code: 'USA' },
    { region: 'AMER', name: 'Uruguay', code: 'URY' },
    // APJ
    { region: 'APJ', name: 'Australia', code: 'AUS' },
    { region: 'APJ', name: 'Bangladesh', code: 'BGD' },
    { region: 'APJ', name: 'Bhutan', code: 'BTN' },
    { region: 'APJ', name: 'Brunei', code: 'BRN' },
    { region: 'APJ', name: 'Cambodia', code: 'KHM' },
    { region: 'APJ', name: 'China', code: 'CHN' },
    { region: 'APJ', name: 'East Timor', code: 'TLS' },
    { region: 'APJ', name: 'Fiji', code: 'FJI' },
    { region: 'APJ', name: 'India', code: 'IND' },
    { region: 'APJ', name: 'Indonesia', code: 'IDN' },
    { region: 'APJ', name: 'Japan', code: 'JPN' },
    { region: 'APJ', name: 'Kiribati', code: 'KIR' },
    { region: 'APJ', name: 'Laos', code: 'LAO' },
    { region: 'APJ', name: 'Malaysia', code: 'MYS' },
    { region: 'APJ', name: 'Maldives', code: 'MDV' },
    { region: 'APJ', name: 'Marshall Islands', code: 'MHL' },
    { region: 'APJ', name: 'Micronesia', code: 'FSM' },
    { region: 'APJ', name: 'Mongolia', code: 'MNG' },
    { region: 'APJ', name: 'Myanmar', code: 'MMR' },
    { region: 'APJ', name: 'Nauru', code: 'NRU' },
    { region: 'APJ', name: 'Nepal', code: 'NPL' },
    { region: 'APJ', name: 'New Zealand', code: 'NZL' },
    { region: 'APJ', name: 'North Korea', code: 'PRK' },
    { region: 'APJ', name: 'Pakistan', code: 'PAK' },
    { region: 'APJ', name: 'Palau', code: 'PLW' },
    { region: 'APJ', name: 'Papua New Guinea', code: 'PNG' },
    { region: 'APJ', name: 'Philippines', code: 'PHL' },
    { region: 'APJ', name: 'Samoa', code: 'WSM' },
    { region: 'APJ', name: 'Singapore', code: 'SGP' },
    { region: 'APJ', name: 'Solomon Islands', code: 'SLB' },
    { region: 'APJ', name: 'South Korea', code: 'KOR' },
    { region: 'APJ', name: 'Sri Lanka', code: 'LKA' },
    { region: 'APJ', name: 'Taiwan', code: 'TWN' },
    { region: 'APJ', name: 'Tajikistan', code: 'TJK' },
    { region: 'APJ', name: 'Thailand', code: 'THA' },
    { region: 'APJ', name: 'Tonga', code: 'TON' },
    { region: 'APJ', name: 'Turkmenistan', code: 'TKM' },
    { region: 'APJ', name: 'Tuvalu', code: 'TUV' },
    { region: 'APJ', name: 'Vanuatu', code: 'VUT' },
    { region: 'APJ', name: 'Vietnam', code: 'VNM' },
    // EMEA
    { region: 'EMEA', name: 'Albania', code: 'ALB' },
    { region: 'EMEA', name: 'Algeria', code: 'DZA' },
    { region: 'EMEA', name: 'Andorra', code: 'AND' },
    { region: 'EMEA', name: 'Angola', code: 'AGO' },
    { region: 'EMEA', name: 'Austria', code: 'AUT' },
    { region: 'EMEA', name: 'Azerbaijan', code: 'AZE' },
    { region: 'EMEA', name: 'Bahrain', code: 'BHR' },
    { region: 'EMEA', name: 'Belgium', code: 'BEL' },
    { region: 'EMEA', name: 'Benin', code: 'BEN' },
    { region: 'EMEA', name: 'Bosnia and Herzegovina', code: 'BIH' },
    { region: 'EMEA', name: 'Botswana', code: 'BWA' },
    { region: 'EMEA', name: 'Bulgaria', code: 'BGR' },
    { region: 'EMEA', name: 'Burkina Faso', code: 'BFA' },
    { region: 'EMEA', name: 'Cameroon', code: 'CMR' },
    { region: 'EMEA', name: 'Cape Verde', code: 'CPV' },
    { region: 'EMEA', name: 'Comoros', code: 'COM' },
    { region: 'EMEA', name: 'Congo', code: 'COG' },
    { region: 'EMEA', name: 'the Democratic Republic of the Congo', code: 'COD' },
    { region: 'EMEA', name: 'Croatia', code: 'HRV' },
    { region: 'EMEA', name: 'Cyprus', code: 'CYP' },
    { region: 'EMEA', name: 'Czech Republic', code: 'CZE' },
    { region: 'EMEA', name: 'Denmark', code: 'DNK' },
    { region: 'EMEA', name: 'Djibouti', code: 'DJI' },
    { region: 'EMEA', name: 'Egypt', code: 'EGY' },
    { region: 'EMEA', name: 'Equatorial Guinea', code: 'GNQ' },
    { region: 'EMEA', name: 'Eritrea', code: 'ERI' },
    { region: 'EMEA', name: 'Estonia', code: 'EST' },
    { region: 'EMEA', name: 'Eswatini', code: 'SWZ' },
    { region: 'EMEA', name: 'Ethiopia', code: 'ETH' },
    { region: 'EMEA', name: 'Finland', code: 'FIN' },
    { region: 'EMEA', name: 'France', code: 'FRA' },
    { region: 'EMEA', name: 'Gabon', code: 'GAB' },
    { region: 'EMEA', name: 'Gambia', code: 'GMB' },
    { region: 'EMEA', name: 'Georgia', code: 'GEO' },
    { region: 'EMEA', name: 'Germany', code: 'DEU' },
    { region: 'EMEA', name: 'Ghana', code: 'GHA' },
    { region: 'EMEA', name: 'Greece', code: 'GRC' },
    { region: 'EMEA', name: 'Guinea', code: 'GIN' },
    { region: 'EMEA', name: 'Guinea-Bissau', code: 'GNB' },
    { region: 'EMEA', name: 'Hungary', code: 'HUN' },
    { region: 'EMEA', name: 'Iceland', code: 'ISL' },
    { region: 'EMEA', name: 'Iran', code: 'IRN' },
    { region: 'EMEA', name: 'Ireland', code: 'IRL' },
    { region: 'EMEA', name: 'Israel', code: 'ISR' },
    { region: 'EMEA', name: 'Italy', code: 'ITA' },
    { region: 'EMEA', name: 'Jordan', code: 'JOR' },
    { region: 'EMEA', name: 'Kenya', code: 'KEN' },
    { region: 'EMEA', name: 'Kuwait', code: 'KWT' },
    { region: 'EMEA', name: 'Latvia', code: 'LVA' },
    { region: 'EMEA', name: 'Lebanon', code: 'LBN' },
    { region: 'EMEA', name: 'Lesotho', code: 'LSO' },
    { region: 'EMEA', name: 'Liberia', code: 'LBR' },
    { region: 'EMEA', name: 'Liechtenstein', code: 'LIE' },
    { region: 'EMEA', name: 'Lithuania', code: 'LTU' },
    { region: 'EMEA', name: 'Luxembourg', code: 'LUX' },
    { region: 'EMEA', name: 'Madagascar', code: 'MDG' },
    { region: 'EMEA', name: 'Malawi', code: 'MWI' },
    { region: 'EMEA', name: 'Malta', code: 'MLT' },
    { region: 'EMEA', name: 'Mauritania', code: 'MRT' },
    { region: 'EMEA', name: 'Mauritius', code: 'MUS' },
    { region: 'EMEA', name: 'Moldova', code: 'MDA' },
    { region: 'EMEA', name: 'Monaco', code: 'MCO' },
    { region: 'EMEA', name: 'Montenegro', code: 'MNE' },
    { region: 'EMEA', name: 'Morocco', code: 'MAR' },
    { region: 'EMEA', name: 'Mozambique', code: 'MOZ' },
    { region: 'EMEA', name: 'Namibia', code: 'NAM' },
    { region: 'EMEA', name: 'Netherlands', code: 'NLD' },
    { region: 'EMEA', name: 'Niger', code: 'NER' },
    { region: 'EMEA', name: 'Nigeria', code: 'NGA' },
    { region: 'EMEA', name: 'North Macedonia', code: 'MKD' },
    { region: 'EMEA', name: 'Norway', code: 'NOR' },
    { region: 'EMEA', name: 'Oman', code: 'OMN' },
    { region: 'EMEA', name: 'Poland', code: 'POL' },
    { region: 'EMEA', name: 'Portugal', code: 'PRT' },
    { region: 'EMEA', name: 'Qatar', code: 'QAT' },
    { region: 'EMEA', name: 'Romania', code: 'ROU' },
    { region: 'EMEA', name: 'Rwanda', code: 'RWA' },
    { region: 'EMEA', name: 'San Marino', code: 'SMR' },
    { region: 'EMEA', name: 'Sao Tome and Principe', code: 'STP' },
    { region: 'EMEA', name: 'Saudi Arabia', code: 'SAU' },
    { region: 'EMEA', name: 'Senegal', code: 'SEN' },
    { region: 'EMEA', name: 'Serbia', code: 'SRB' },
    { region: 'EMEA', name: 'Seychelles', code: 'SYC' },
    { region: 'EMEA', name: 'Sierra Leone', code: 'SLE' },
    { region: 'EMEA', name: 'Slovakia', code: 'SVK' },
    { region: 'EMEA', name: 'Slovenia', code: 'SVN' },
    { region: 'EMEA', name: 'South Africa', code: 'ZAF' },
    { region: 'EMEA', name: 'South Sudan', code: 'SSD' },
    { region: 'EMEA', name: 'Spain', code: 'ESP' },
    { region: 'EMEA', name: 'Sudan', code: 'SDN' },
    { region: 'EMEA', name: 'Sweden', code: 'SWE' },
    { region: 'EMEA', name: 'Switzerland', code: 'CHE' },
    { region: 'EMEA', name: 'Syria', code: 'SYR' },
    { region: 'EMEA', name: 'Tanzania', code: 'TZA' },
    { region: 'EMEA', name: 'Togo', code: 'TGO' },
    { region: 'EMEA', name: 'Tunisia', code: 'TUN' },
    { region: 'EMEA', name: 'Turkey', code: 'TUR' },
    { region: 'EMEA', name: 'Uganda', code: 'UGA' },
    { region: 'EMEA', name: 'Ukraine', code: 'UKR' },
    { region: 'EMEA', name: 'United Arab Emirates', code: 'ARE' },
    { region: 'EMEA', name: 'United Kingdom', code: 'GBR' },
    { region: 'EMEA', name: 'Vatican City', code: 'VAT' },
    { region: 'EMEA', name: 'Zambia', code: 'ZMB' },
];
// Helper function to get region from country name
export const getRegionFromCountryName = (name) => {
    const country = COUNTRY_DETAILS.find(country => country.name === name);
    return country ? country.region : '';
};
// Helper function to get country options for dropdown
export const getCountryOptions = () => {
    return COUNTRY_DETAILS.map(country => ({
        label: country.name,
        value: country.name
    })).sort((a, b) => a.label.localeCompare(b.label));
};
// Helper function to get prices for different Territories for the partners 
/**
 * Returns price per seat for ATP customer based on the selected end customer country
 * @param pricePerSeatMap
 * @param endCustomerCountry
 * @returns
 */
export const getPartnerPricePerSeat = (pricePerSeatMap, endCustomerCountry) => {
    const pricePerSeat = pricePerSeatMap.find((price) => price.territory === endCustomerCountry)?.pricePerSeat;
    return pricePerSeat || 0;
};
export var MarketingSource;
(function (MarketingSource) {
    MarketingSource["DIGITAL_TRAINING"] = "digital_training";
    MarketingSource["TEAM_SUBSCRIPTION"] = "team_subscription";
    MarketingSource["FAQ"] = "faq";
})(MarketingSource || (MarketingSource = {}));
export var CTALocation;
(function (CTALocation) {
    CTALocation["BUILD_CLOUD_SKILLS"] = "build_cloud_skills";
    CTALocation["GET_STARTED"] = "get_started";
    CTALocation["HEADER"] = "header";
})(CTALocation || (CTALocation = {}));
export const PREFERRED_START_DATE_BUFFER_DAYS = {
    BUILDER_ID: 2,
    SSO: 10,
    PARTNER_NETWORK: 2
};
// Keeping  the flag off while FTv2 support is in development
export const ENABLE_FTV2_SUPPORT = {
    [NodeEnvironment.DEVELOPMENT]: true,
    [NodeEnvironment.BETA]: true,
    [NodeEnvironment.GAMMA]: true,
    [NodeEnvironment.PROD]: true,
};
export const TEMP_CREDS_SET_EVENT = "temp-creds-set";
